import React from 'react';
import {
    FinancePartnerSyncModal,
    LeadSyncFormModal,
    IGSLeadSyncModal,
    PartnerApiErrorModal,
} from '..';

interface DashboardAuxiliarySectionProps {
    financePartnerSyncModalOpen: boolean;
    setFinancePartnerSyncModalOpen: (next: boolean) => void;
    leadSyncFormOpen: boolean;
    setLeadSyncFormOpen: (next: boolean) => void;
}

export const DashboardAuxiliarySection: React.FC<DashboardAuxiliarySectionProps> = ({
    financePartnerSyncModalOpen,
    setFinancePartnerSyncModalOpen,
    leadSyncFormOpen,
    setLeadSyncFormOpen,
}) => {
    return (
        <>
            <PartnerApiErrorModal />
            <FinancePartnerSyncModal
                open={financePartnerSyncModalOpen}
                onClose={() => setFinancePartnerSyncModalOpen(false)}
            />
            <LeadSyncFormModal
                open={leadSyncFormOpen}
                onClose={() => setLeadSyncFormOpen(false)}
            />
            <IGSLeadSyncModal />
        </>
    );
};
